// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(app-view-application-professional-bodies-bp) {
  height: calc(100vh - 288px);
  width: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
}

.saverow {
  height: 44px;
  min-height: 44px !important;
  align-items: center;
}

.content-area {
  height: calc(100vh - 288px);
  margin-bottom: 1%;
  margin-right: 36.55px;
  overflow-x: hidden;
  overflow-y: auto;
}

.custom-control-left-alignment {
  padding-left: 24px !important;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
}

.z-index {
  z-index: 9000;
}

.section-header {
  margin-top: 0px !important;
  vertical-align: middle;
  line-height: 34px;
  margin-bottom: 0px !important;
}

.copy-button {
  margin-left: 10px;
}

.copy-applicant-row {
  margin-bottom: 10px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
